<template>

  <div>
      <center><H3>Credit List</H3></center>
      <v-data-table
          class="table"
          :headers="headers"
          :items="details"
          :search="search"
          :rows-per-page-items="[10, 25]">
          <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.point }}</td>
              <td class="text-xs-left">{{ props.item.expire }}</td>
              <td class="text-xs-center">
                  <v-icon class="mr-2" @click="edit_exp(props.item.c_id)">edit</v-icon>
              </td>

          </template>
      </v-data-table>

        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-date-picker v-model="date"></v-date-picker>
                <v-spacer></v-spacer>
                    <v-btn block  @click="hide_dialog()" color="primary">Select</v-btn>
                    <v-btn block @click="hide_clear_dialog()" >Clear</v-btn>
            </v-card>
        </v-dialog>

    </div>  
</template>

<script>
export default {
  data() {
    return {
            headers:[ 
              { text: 'Credit', value: 'point' },
              { text: 'Expire', value: 'expire' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            details: [],
            search: '',
            date: new Date().toISOString().substr(0, 10),
            dialog : false,
            c_id : '',
    }
  },   
  created () {
      console.log("CREATE")
      this.read_data()
  }, 
  methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_credit_list.php',{
                        params: {
                            scode: this.$store.getters.get_user_code ,
                        }
                    }).then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.details = result
            console.log(vm.details)
            });
        },
        edit_exp( c_id ){
          this.c_id = c_id
          this.dialog = true
        },
        hide_dialog(){
          this.edit_prod()
          this.dialog = false
        },
        hide_clear_dialog(){
            var date_clear = new Date().toISOString().substr(0, 10)
            this.date = date_clear
            this.dialog = false
        },
        edit_prod(){

            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/post_edit_expire_date.php',{
                params: {
                    scode: this.c_id ,
                    sdate: this.date ,
                }
            }).then(response => {
              this.read_data()
            });

        },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/view_table_credit.vue